import BaseDOM, {
	BASE_ELEMENT_IDS as BASE_ELEMENT_IDS,
	createButton,
	insertAfter,
} from "../BaseDOM";
import { inject } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig, { CONFIG_PARAMS, MODES } from "../../system/SystemConfig";
import IUIMessages from "../messages/IUIMessages";
import { ACTION_EVENTS } from "../UserAction";
import BottomBoxComponent from "./BottomBoxComponent";
import MadnesIframe from "../components/MadnesIframe";
import Wallet from "../../wallet/Wallet";
import IGame from "../../game/IGame";
import { translate } from "../../translations/translations";
import { EASE } from "../../modules/Tween";
import DesktopAutostart from "./DesktopAutostart";
import { MESSAGE_EVENTS } from "../../error/errorMessages";
import events from "../../events/EventsObservable";

export const ELEMENT_IDS = {
	BUTTON_INFO: "mxButtonInfo",
	BUTTON_SOUND: "mxButtonSound",
	BUTTON_FULLSCREEN: "mxButtonFullscreen",
	BUTTON_HOME: "mxButtonHome",
	BUTTON_HISTORY: "mxButtonHistory",
	BUTTON_PARAGRAPH: "mxButtonParagraph",
	BUTTON_FREESPINS: "mxButtonFreespins",

	CREDIT: "mxCredit",
	BALANCE: "mxBalance",
	WIN: "mxWin",
	WIN_REAL: "mxWinReal",
	COIN_VALUE: "mxCoinValue",
	FREE_SPINS: "mxFreeSpins",
	LINES: "mxLines",
	BET_CREDIT_ATOMIC: "mxBetCreditAtomic",
	BET_REAL: "mxBetReal",
	BET_LINE_TOTAL: "mxBetLineTotal",

	WIN_BOX: "mxWinBox",

	AUTOSTART_MENU: "mxAutostartMenu",
	AUTOSTART_BTN: "mxAutostartBtn",
	BUTTON_AUTOSTART_CONTINUE: "mxButtonAutostartContinue",

	INFO_BUTTON_LEFT: "mxInfoButtonLeft",
	INFO_BUTTON_RIGHT: "mxInfoButtonRight",

	BUTTON_BET_INC: "mxButtonBetInc",
	BUTTON_BET_DEC: "mxButtonBetDec",
	BUTTON_COIN_INC: "mxButtonCoinInc",
	BUTTON_COIN_DEC: "mxButtonCoinDec",
	BUTTON_MAX_BET: "mxButtonMaxBet",
	BUTTON_LINES_INC: "mxButtonLinesInc",
	BUTTON_LINES_DEC: "mxButtonLinesDec",

	BAR_LOGO: "mxBarLogo",
	LUCK: "luck",
};

export default class DesktopDOM extends BaseDOM {
	private barTop: HTMLElement;
	private topBtnsWrapper: HTMLElement;

	public creditBox: BottomBoxComponent;
	public winBox: BottomBoxComponent;
	public betBox: BottomBoxComponent;
	public coinBox: BottomBoxComponent;
	public fsBox: BottomBoxComponent;
	public betLineBox: BottomBoxComponent;
	public linesBox: BottomBoxComponent;

	public iframeParagraph: MadnesIframe;
	public iframeHistory: MadnesIframe;

	private bottomBarLeft: HTMLElement;
	private bottomBarRight: HTMLElement;
	private betBoxElement: HTMLElement;
	private linesBoxElement: HTMLElement;
	private betLinesBoxElement: HTMLElement;
	private winBoxElement: HTMLElement;
	private coinBoxElement: HTMLElement;
	private fsBoxElement: HTMLElement;

	public autostart: DesktopAutostart;

	public freeSpinsShown: boolean;
	private fsButtonContainer: HTMLElement;

	protected winToBalanceRunning: boolean;
	protected winToBalancePromises: Array<Promise<any>> = [];

	private onClick: any;
	respins: HTMLElement | undefined = undefined;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.UIMessages) uiMessages: IUIMessages,
		@inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
		@inject(SERVICE_IDENTIFIER.Game) game: IGame
	) {
		super(config, uiMessages, wallet, game);
		this.getCssStyles();
		this.winToBalanceRunning = false;
	}

	getCssStyles() {
		$("head").append(
			'<link rel="stylesheet" type="text/css" href="desktop.css">'
		);
	}

	createDOM() {
		super.createDOM();

		this.createGameControlWrapper();
		this.createWintableControlWrapper();
		this.createIframes();
	}

	private createGameControlWrapper() {
		let parent = this.gameControlsWrapper;

		let barTop = (this.barTop = document.createElement("div"));
		barTop.classList.add("mx-bar-top-desktop");
		parent.appendChild(barTop);

		let topBtnsWrapper = (this.topBtnsWrapper = document.createElement("div"));
		barTop.appendChild(topBtnsWrapper);

		if (this.config.get(CONFIG_PARAMS.HOME_SETTINGS)?.desktop === true) {
			let btnHome = document.createElement("button");
			btnHome.id = ELEMENT_IDS.BUTTON_HOME;
			btnHome.classList.add(
				"mx-input",
				"mx-button",
				"mx-button-desk-top",
				"mx-button-desk-top-home"
			);
			$(btnHome).data("action", ACTION_EVENTS.ACTION_HOME_BUTTON);
			topBtnsWrapper.appendChild(btnHome);
		}

		let btnInfo = document.createElement("button");
		btnInfo.id = ELEMENT_IDS.BUTTON_INFO;
		btnInfo.classList.add(
			"mx-input",
			"mx-button",
			"mx-button-desk-top",
			"mx-button-desk-top-info"
		);
		$(btnInfo).data("action", ACTION_EVENTS.ACTION_INFO_TOGGLE);
		topBtnsWrapper.appendChild(btnInfo);

		let btnSound = document.createElement("button");
		btnSound.id = ELEMENT_IDS.BUTTON_SOUND;
		btnSound.classList.add("mx-input", "mx-button", "mx-button-desk-top");
		$(btnSound).data("action", ACTION_EVENTS.ACTION_SOUND_TOGGLE);
		topBtnsWrapper.appendChild(btnSound);
		this.toggleSoundButton(false);

		let topInfoWrapper = document.createElement("div");
		barTop.appendChild(topInfoWrapper);

		let boxClock = document.createElement("div");
		boxClock.classList.add("mx-bar-top-info-box");
		let boxTime = document.createElement("div");
		boxTime.id = BASE_ELEMENT_IDS.TIME;
		boxTime.classList.add(
			"mx-bar-top-info-box",
			"mx-bar-top-clock",
			"mx-grey-text"
		);
		boxClock.appendChild(boxTime);
        let kajotLogo = document.createElement("img");
        const isBellot = this.config.get(CONFIG_PARAMS.BRAND_NAME) === "bellot";
        const logo = isBellot
            ? require("../../../../framework/assets/img/inline/ui/logo_new.svg")
            : require("../../../../framework/assets/img/inline/ui/logo_kajot.svg");
        kajotLogo.classList.add("mx-bar-top-logo");
        kajotLogo.src = logo;
        boxClock.appendChild(kajotLogo);
        topInfoWrapper.appendChild(boxClock);

		let loss = document.createElement("div");
		loss.classList.add("mx-bar-top-info-box");
		loss.id = BASE_ELEMENT_IDS.INFO_BOX_BALANCE;
		topInfoWrapper.appendChild(loss);
		$(loss).hide();

		let lossIcon = document.createElement("div");
		lossIcon.classList.add("mx-bar-top-loss-icon");
		lossIcon.id = BASE_ELEMENT_IDS.INFO_BOX_BALANCE_IMAGE;
		loss.appendChild(lossIcon);

		let lossText = document.createElement("span");
		lossText.classList.add("mx-grey-text");
		lossText.id = BASE_ELEMENT_IDS.INFO_BOX_BALANCE_VALUE;
		loss.appendChild(lossText);

		let boxWarning = document.createElement("div");
		boxWarning.id = BASE_ELEMENT_IDS.INFO_BOX_WARNING;
		boxWarning.classList.add("mx-bar-top-info-box", "mx-grey-text");
		boxWarning.innerHTML = translate(
			"text_warning",
			this.config.get(CONFIG_PARAMS.LANGUAGE)
		);
		$(boxWarning).hide();
		topInfoWrapper.appendChild(boxWarning);

		let bottomBar = document.createElement("div");
		bottomBar.classList.add("mx-bar-bottom-desktop");
		parent.appendChild(bottomBar);

		let spinBtnBg = document.createElement("div");
		spinBtnBg.classList.add("bar-bottom-spin-bg");
		bottomBar.appendChild(spinBtnBg);

		let bottomBarLeft = document.createElement("div");
		bottomBarLeft.classList.add("mx-bar-bottom-left");
		bottomBar.appendChild(bottomBarLeft);
		this.bottomBarLeft = bottomBarLeft;

		let creditBox = document.createElement("div");
		creditBox.classList.add("bar-bottom-box");
		bottomBarLeft.appendChild(creditBox);
		this.creditBox = new BottomBoxComponent({
			name: "credit",
			el: creditBox,
			valueId: ELEMENT_IDS.CREDIT,
		});

		let winBox = document.createElement("div");
		winBox.id = ELEMENT_IDS.WIN_BOX;
		winBox.classList.add("bar-bottom-box");
		bottomBarLeft.appendChild(winBox);
		this.winBox = new BottomBoxComponent({
			name: "win_credit",
			el: winBox,
			valueId: ELEMENT_IDS.WIN,
		});
		this.winBoxElement = winBox;

		let betBox = document.createElement("div");
		betBox.classList.add("bar-bottom-box");
		bottomBarLeft.appendChild(betBox);
		this.betBoxElement = betBox;

		let maxbetBtn = document.createElement("button");
		maxbetBtn.id = ELEMENT_IDS.BUTTON_MAX_BET;
		maxbetBtn.classList.add(
			"mx-input",
			"mx-button",
			"bar-bottom-button",
			"btn-desk-maxbet"
		);
		$(maxbetBtn).data("action", ACTION_EVENTS.ACTION_MAXBET);
		bottomBarLeft.appendChild(maxbetBtn);

		let bottomBarRight = document.createElement("div");
		bottomBarRight.classList.add("mx-bar-bottom-right");
		bottomBar.appendChild(bottomBarRight);
		this.bottomBarRight = bottomBarRight;

		let linesBox = document.createElement("div");
		linesBox.classList.add("bar-bottom-box");
		bottomBarRight.appendChild(linesBox);
		this.linesBoxElement = linesBox;
		this.linesBox = new BottomBoxComponent({
			name: "line",
			el: linesBox,
			btns: true,
			valueId: ELEMENT_IDS.LINES,
		});
		$(this.linesBox.leftBtn).data("action", ACTION_EVENTS.ACTION_LINES_DEC);
		$(this.linesBox.rightBtn).data("action", ACTION_EVENTS.ACTION_LINES_INC);
		this.linesBox.leftBtn.id = ELEMENT_IDS.BUTTON_LINES_DEC;
		this.linesBox.rightBtn.id = ELEMENT_IDS.BUTTON_LINES_INC;

		let coinBox = document.createElement("div");
		coinBox.classList.add("bar-bottom-box");
		bottomBarRight.appendChild(coinBox);
		this.coinBoxElement = coinBox;
		this.coinBox = new BottomBoxComponent({
			name: "coin_value",
			el: coinBox,
			btns: true,
			valueId: ELEMENT_IDS.COIN_VALUE,
		});
		$(this.coinBox.leftBtn).data("action", ACTION_EVENTS.ACTION_COIN_DEC);
		$(this.coinBox.rightBtn).data("action", ACTION_EVENTS.ACTION_COIN_INC);
		this.coinBox.leftBtn.id = ELEMENT_IDS.BUTTON_COIN_DEC;
		this.coinBox.rightBtn.id = ELEMENT_IDS.BUTTON_COIN_INC;

		let fsBox = document.createElement("div");
		fsBox.classList.add("bar-bottom-box");
		bottomBarRight.appendChild(fsBox);
		this.fsBoxElement = fsBox;
		this.fsBox = new BottomBoxComponent({
			name: "freespins",
			el: fsBox,
			btns: false,
			valueId: ELEMENT_IDS.FREE_SPINS,
		});
		this.hideFreeSpins();
		// $(this.fsBox.leftBtn).data("action", ACTION_EVENTS.ACTION_COIN_DEC);
		// $(this.fsBox.rightBtn).data("action", ACTION_EVENTS.ACTION_COIN_INC);
		// this.fsBox.leftBtn.id = ELEMENT_IDS.BUTTON_COIN_DEC;
		// this.fsBox.rightBtn.id = ELEMENT_IDS.BUTTON_COIN_INC;

		let betLinesBox = document.createElement("div");
		betLinesBox.classList.add("bar-bottom-box");
		bottomBarRight.appendChild(betLinesBox);
		this.betLinesBoxElement = betLinesBox;

		let autostartBtn = document.createElement("button");
		autostartBtn.classList.add(
			"mx-input",
			"mx-button",
			"bar-bottom-button",
			"btn-desk-autostart"
		);
		autostartBtn.id = ELEMENT_IDS.AUTOSTART_BTN;
		$(autostartBtn).data("action", ACTION_EVENTS.ACTION_AUTOSTART_OPEN);
		bottomBarRight.appendChild(autostartBtn);

		this.spinBtns[BASE_ELEMENT_IDS.BUTTON_SPIN] = createButton({
			id: BASE_ELEMENT_IDS.BUTTON_SPIN,
			classes: [
				"mx-input",
				"mx-button",
				"bar-bottom-center-button",
				"mx-desk-button-spin",
			],
			action: ACTION_EVENTS.ACTION_SPIN,
			parent: bottomBar,
		});

		this.spinBtns[BASE_ELEMENT_IDS.BUTTON_SPIN_AUTOSTART] = createButton({
			id: BASE_ELEMENT_IDS.BUTTON_SPIN_AUTOSTART,
			classes: [
				"mx-input",
				"mx-button",
				"bar-bottom-center-button",
				"mx-desk-button-spin-autostart",
			],
			action: ACTION_EVENTS.ACTION_SPIN,
			parent: bottomBar,
		});

		this.spinBtns[BASE_ELEMENT_IDS.BUTTON_SKIP] = createButton({
			id: BASE_ELEMENT_IDS.BUTTON_SKIP,
			classes: [
				"mx-input",
				"mx-button",
				"bar-bottom-center-button",
				"mx-desk-button-skip",
			],
			action: ACTION_EVENTS.ACTION_SKIP,
			parent: bottomBar,
		});

		this.spinBtns[BASE_ELEMENT_IDS.BUTTON_STOP] = createButton({
			id: BASE_ELEMENT_IDS.BUTTON_STOP,
			classes: [
				"mx-input",
				"mx-button",
				"bar-bottom-center-button",
				"mx-desk-button-stop",
			],
			action: ACTION_EVENTS.ACTION_FORCESTOP,
			parent: bottomBar,
		});

		this.spinBtns[BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART] = createButton({
			id: BASE_ELEMENT_IDS.BUTTON_STOP_AUTOSTART,
			classes: [
				"mx-input",
				"mx-button",
				"bar-bottom-center-button",
				"mx-desk-button-stop-autostart",
			],
			action: ACTION_EVENTS.ACTION_AUTOSTART_STOP,
			parent: bottomBar,
		});

		this.spinBtns[BASE_ELEMENT_IDS.BUTTON_STOP_BONUS_WHEEL] = createButton({
			id: BASE_ELEMENT_IDS.BUTTON_STOP_BONUS_WHEEL,
			classes: [
				"mx-input",
				"mx-button",
				"bar-bottom-center-button",
				"mx-desk-button-stop",
			],
			action: ACTION_EVENTS.ACTION_BONUS_WHEEL_STOP,
			parent: bottomBar,
		});

		this.spinBtns[BASE_ELEMENT_IDS.BUTTON_PREINFO_CLOSE] = createButton({
			id: BASE_ELEMENT_IDS.BUTTON_PREINFO_CLOSE,
			classes: [
				"mx-input",
				"mx-button",
				"bar-bottom-center-button",
				"mx-desk-button-preinfo-close",
			],
			action: ACTION_EVENTS.ACTION_PREINFO_CLOSE,
			parent: bottomBar,
		});

		// this.spinBtns[BASE_ELEMENT_IDS.BUTTON_FORCESPIN] = createButton({
		//     id: BASE_ELEMENT_IDS.BUTTON_FORCESPIN,
		//     classes: ["mx-input", "mx-button", "bar-bottom-center-button", "mx-desk-button-forcespin"],
		//     action: ACTION_EVENTS.ACTION_SPIN,
		//     parent: bottomBar
		// });

		let bottomBarLeftContainer = document.createElement("div");
		bottomBarLeftContainer.classList.add(
			"mx-bottom-bar-box",
			"mx-bottom-bar-box-left"
		);
		bottomBarLeft.appendChild(bottomBarLeftContainer);

		let balanceBarBox = document.createElement("div");
		bottomBarLeftContainer.appendChild(balanceBarBox);

		let balanceTitle = document.createElement("span");
		balanceTitle.classList.add("mx-translate", "mx-bar-title");
		balanceTitle.setAttribute("data-lang", "balance");
		balanceBarBox.appendChild(balanceTitle);

		let balanceValue = document.createElement("span");
		balanceValue.id = ELEMENT_IDS.BALANCE;
		balanceBarBox.appendChild(balanceValue);

		let winBarBox = document.createElement("div");
		bottomBarLeftContainer.appendChild(winBarBox);

		let winTitle = document.createElement("span");
		winTitle.classList.add("mx-translate", "mx-bar-title");
		winTitle.setAttribute("data-lang", "win");
		winBarBox.appendChild(winTitle);

		let winValue = document.createElement("span");
		winValue.id = ELEMENT_IDS.WIN_REAL;
		winBarBox.appendChild(winValue);

		let betBarBox = document.createElement("div");
		bottomBarLeftContainer.appendChild(betBarBox);

		let betTitle = document.createElement("span");
		betTitle.classList.add("mx-translate", "mx-bar-title");
		betTitle.setAttribute("data-lang", "bet");
		betBarBox.appendChild(betTitle);

		let betValue = document.createElement("span");
		betValue.id = ELEMENT_IDS.BET_REAL;
		betBarBox.appendChild(betValue);

		let bottomBarRightContiner = document.createElement("div");
		bottomBarRightContiner.classList.add(
			"mx-bottom-bar-box",
			"mx-bottom-bar-box-right"
		);
		bottomBarRight.appendChild(bottomBarRightContiner);

		if (this.config.get(CONFIG_PARAMS.LEGISLATION) === "it") {
			bottomBarRightContiner.append(this.createRespins());
		}

		let luck = document.createElement("div");
		luck.id = ELEMENT_IDS.LUCK;
		if (this.config.get(CONFIG_PARAMS.MODE) === MODES.REAL) {
			luck.innerText =
				translate("luck", this.config.get(CONFIG_PARAMS.LANGUAGE)) +
				this.config.gameset.gameName;
		} else if (this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
			luck.innerText = "REPLAY MODE";
		} else {
			luck.innerText = this.config.gameset.gameName;
		}
		bottomBarRightContiner.appendChild(luck);

		this.fsButtonContainer = document.createElement("button");
		this.fsButtonContainer.classList.add(
			"mx-button-desk-top",
			"mx-input",
			"mx-freespins-container"
		);
		this.fsButtonContainer.id = ELEMENT_IDS.BUTTON_FREESPINS;
		$(this.fsButtonContainer).data(
			"action",
			MESSAGE_EVENTS.SWITCH_TO_FREESPINS
		);
		let freespinsButtonGift = document.createElement("span");
		freespinsButtonGift.classList.add("mx-freespins-container-gift");
		this.fsButtonContainer.appendChild(freespinsButtonGift);
		let freespinsButtonText = document.createElement("span");
		freespinsButtonText.innerText = translate(
			"freespins_desktop_btn",
			this.config.get(CONFIG_PARAMS.LANGUAGE)
		);
		this.fsButtonContainer.appendChild(freespinsButtonText);
		let freespinsButton = document.createElement("span");
		freespinsButton.classList.add("mx-freespins-container-play");
		this.fsButtonContainer.appendChild(freespinsButton);
		this.barTop.insertBefore(this.fsButtonContainer, topInfoWrapper);
		$(this.fsButtonContainer).hide();
	}

	init() {
		super.init();

		if (this.config.get(CONFIG_PARAMS.MODE) === MODES.REAL) {
			if (
				this.config.get(CONFIG_PARAMS.URL_HISTORY_PARAM) ||
				this.config.get(CONFIG_PARAMS.IS_HISTORY)
			) {
				let btnHistory = document.createElement("button");
				btnHistory.id = ELEMENT_IDS.BUTTON_HISTORY;
				btnHistory.classList.add(
					"mx-input",
					"mx-button",
					"mx-button-desk-top",
					"mx-button-desk-top-history"
				);
				$(btnHistory).data("action", ACTION_EVENTS.ACTION_HISTORY_OPEN);
				this.topBtnsWrapper.appendChild(btnHistory);
			}
		}

		if (this.config.get(CONFIG_PARAMS.IS_PARAGRAPH)) {
			let btnParagraph = document.createElement("button");
			btnParagraph.id = ELEMENT_IDS.BUTTON_PARAGRAPH;
			btnParagraph.classList.add(
				"mx-input",
				"mx-button",
				"mx-button-desk-top",
				"mx-button-desk-top-paragraph"
			);
			$(btnParagraph).data("action", ACTION_EVENTS.ACTION_PARAGRAPH_OPEN);
			this.topBtnsWrapper.appendChild(btnParagraph);
		}

		if (this.config.get(CONFIG_PARAMS.FULLSCREEN)) {
			let btnFullscreen = document.createElement("button");
			btnFullscreen.id = ELEMENT_IDS.BUTTON_FULLSCREEN;
			btnFullscreen.classList.add(
				"mx-input",
				"mx-button",
				"mx-button-desk-top"
			);
			$(btnFullscreen).data("action", ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST);
			this.topBtnsWrapper.appendChild(btnFullscreen);
			this.toggleFullscreenButton();
		}
		if (this.config.get(CONFIG_PARAMS.WARNING_MESSAGE)) {
			$(`#${BASE_ELEMENT_IDS.INFO_BOX_WARNING}`).show();
		}
		let responsibleGaming = document.createElement("button");
		responsibleGaming.id = BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING;
		responsibleGaming.classList.add(
			"mx-button",
			"mx-input",
			"mx-button-desk-top",
			"mx-button-responsible-gaming"
		);
		$(responsibleGaming).data(
			"action",
			ACTION_EVENTS.ACTION_RESPONSIBLE_GAMING
		);
		$(responsibleGaming).hide();
		this.topBtnsWrapper.appendChild(responsibleGaming);

		if (this.config.get(CONFIG_PARAMS.ONLY_COINS) == 1) {
			$("#" + ELEMENT_IDS.BUTTON_BET_INC)
				.hide()
				.parent()
				.css("justify-content", "center");
			$("#" + ELEMENT_IDS.BUTTON_BET_DEC).hide();
		}
	}

	createAutostartMenu() {
		if (!this.config.get(CONFIG_PARAMS.DISABLE_AUTOSTART)) {
			this.game.autostart?.setSettings(
				this.config.get(CONFIG_PARAMS.AUTOSTART)
			);
			this.autostart = new DesktopAutostart(
				this.gameControlsWrapper,
				this.game.autostart,
				this.wallet
			);
			this.autostart?.create();
		}
	}

	protected createWintableControlWrapper() {
		let parent = this.wintableButtonsContainer;

		let wintableLeftButton = document.createElement("button");
		wintableLeftButton.classList.add(
			"mx-button",
			"mx-input",
			"mx-wintable-btn",
			"mx-wintable-btn-left"
		);
		$(wintableLeftButton).data("action", ACTION_EVENTS.ACTION_INFO_ARROW);
		$(wintableLeftButton).data("data", "left");
		parent.appendChild(wintableLeftButton);

		let wintableRightButton = document.createElement("button");
		wintableRightButton.classList.add(
			"mx-button",
			"mx-input",
			"mx-wintable-btn",
			"mx-wintable-btn-right"
		);
		$(wintableRightButton).data("action", ACTION_EVENTS.ACTION_INFO_ARROW);
		$(wintableRightButton).data("data", "right");
		parent.appendChild(wintableRightButton);
	}

	private createIframes() {
		let config = this.config;
		let parent = document.getElementById(BASE_ELEMENT_IDS.WRAPPER);

		this.iframeParagraph = new MadnesIframe({
			parent,
			appName: "pages",
			systemConfig: this.config,
		});
		this.iframeParagraph.create();

		this.iframeHistory = new MadnesIframe({
			parent,
			appName: "history",
			systemConfig: this.config,
		});
		this.iframeHistory.create();
	}

	public toggleSoundButton(mute) {
		let button = document.getElementById(ELEMENT_IDS.BUTTON_SOUND);

		if (!mute) {
			button.classList.remove("mx-button-desk-top-sound-off");
			button.classList.add("mx-button-desk-top-sound-on");
		} else {
			button.classList.remove("mx-button-desk-top-sound-on");
			button.classList.add("mx-button-desk-top-sound-off");
		}
	}

	public toggleFullscreenButton(inFullscreen = false) {
		let button = document.getElementById(ELEMENT_IDS.BUTTON_FULLSCREEN);
		if (!button) return
		button.blur();

		if (inFullscreen) {
			button.classList.remove("mx-button-desk-top-fullscreen");
			button.classList.add("mx-button-desk-top-smallscreen");
			$(button).data("action", ACTION_EVENTS.ACTION_FULLSCREEN_EXIT_REQUEST);
		} else {
			button.classList.remove("mx-button-desk-top-smallscreen");
			button.classList.add("mx-button-desk-top-fullscreen");
			$(button).data("action", ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST);
		}
	}

	public initBottomBar() {
		let btnBetDec;
		let btnBetInc;

		if (this.wallet.getLines().length > 1) {
			this.betBox = new BottomBoxComponent({
				name: "bet_total",
				el: this.betBoxElement,
				btns: false,
				valueId: ELEMENT_IDS.BET_LINE_TOTAL,
			});

			this.betLineBox = new BottomBoxComponent({
				name: "bet_line",
				el: this.betLinesBoxElement,
				btns: true,
				valueId: ELEMENT_IDS.BET_CREDIT_ATOMIC,
			});
			btnBetDec = this.betLineBox.leftBtn;
			btnBetInc = this.betLineBox.rightBtn;

			// TODO: separate games with level and lines
			if (this.config.get(CONFIG_PARAMS.GAME_ID) === "monster_slots") {
				// this.betBox.rename("total_bet");
				this.linesBox.rename("level");
				this.betLineBox.rename("bet_level");
			}
		} else {
			this.betBox = new BottomBoxComponent({
				name: "bet_total",
				el: this.betBoxElement,
				btns: true,
				valueId: ELEMENT_IDS.BET_LINE_TOTAL,
			});
			btnBetDec = this.betBox.leftBtn;
			btnBetInc = this.betBox.rightBtn;

			this.betLineBox = new BottomBoxComponent({
				name: "bet_line",
				el: this.betLinesBoxElement,
				btns: false,
				valueId: ELEMENT_IDS.BET_CREDIT_ATOMIC,
			});
			$(this.betLinesBoxElement).hide();
			$(this.linesBoxElement).hide();

			insertAfter(this.betBoxElement, this.fsBoxElement);
		}

		$(btnBetDec).data("action", ACTION_EVENTS.ACTION_BET_DEC);
		$(btnBetInc).data("action", ACTION_EVENTS.ACTION_BET_INC);
		btnBetDec.id = ELEMENT_IDS.BUTTON_BET_DEC;
		btnBetInc.id = ELEMENT_IDS.BUTTON_BET_INC;
	}

	public showFreeSpins() {
		console.log("show fs")
		this.freeSpinsShown = true;
		if(this.config.get(CONFIG_PARAMS.USE_FS_TOTAL_WIN)){
			$(`.bar-bottom-box .bottom-box-title[data-lang="credit"]`).text(translate("freespins_continue_total_win",this.config.get(CONFIG_PARAMS.LANGUAGE)))
			$(`.mx-bottom-bar-box-left .mx-bar-title[data-lang="balance"]`).text(translate("freespins_continue_total_win",this.config.get(CONFIG_PARAMS.LANGUAGE)))
		}
		$(this.fsBoxElement).show();
		$(this.coinBoxElement).hide();
		$(this.fsButtonContainer).hide();

		let betInc = $(`#` + ELEMENT_IDS.BUTTON_BET_INC);
		let betDec = $(`#` + ELEMENT_IDS.BUTTON_BET_DEC);
		betInc.prop("disabled", true);
		betDec.prop("disabled", true);
		betInc.css("opacity", 0);
		betDec.css("opacity", 0);
		betInc.css("cursor", "initial");
		betDec.css("cursor", "initial");
		$(`#` + ELEMENT_IDS.BUTTON_MAX_BET).prop("disabled", true);
		let lineInc = $(`#` + ELEMENT_IDS.BUTTON_LINES_INC);
		let lineDec = $(`#` + ELEMENT_IDS.BUTTON_LINES_DEC);
		lineInc.prop("disabled", true);
		lineDec.prop("disabled", true);
		lineInc.css("opacity", 0);
		lineDec.css("opacity", 0);
		lineInc.css("cursor", "initial");
		lineDec.css("cursor", "initial");
	}

	public hideFreeSpins() {
		this.freeSpinsShown = false;
		$(`.bar-bottom-box .bottom-box-title[data-lang="credit"]`).text(translate("credit",this.config.get(CONFIG_PARAMS.LANGUAGE)))
		$(`.mx-bottom-bar-box-left .mx-bar-title[data-lang="balance"]`).text(translate("balance",this.config.get(CONFIG_PARAMS.LANGUAGE)))
		$(this.coinBoxElement).show();
		$(this.fsBoxElement).hide();
		$(`#` + ELEMENT_IDS.BUTTON_MAX_BET).prop("disabled", false);
		// $(`#`+ELEMENT_IDS.AUTOSTART_BTN).prop('disabled', false);
		if (this.wallet.isValidBonusBet() && this.wallet.getFreeSpins() > 0) {
			$(this.fsButtonContainer).show();
		}

		let betInc = $(`#` + ELEMENT_IDS.BUTTON_BET_INC);
		let betDec = $(`#` + ELEMENT_IDS.BUTTON_BET_DEC);
		betInc.prop("disabled", false);
		betDec.prop("disabled", false);
		betInc.css("opacity", 1);
		betDec.css("opacity", 1);
		betInc.css("cursor", "hand");
		betDec.css("cursor", "hand");
		let lineInc = $(`#` + ELEMENT_IDS.BUTTON_LINES_INC);
		let lineDec = $(`#` + ELEMENT_IDS.BUTTON_LINES_DEC);
		lineInc.prop("disabled", false);
		lineDec.prop("disabled", false);
		lineInc.css("opacity", 1);
		lineDec.css("opacity", 1);
		lineInc.css("cursor", "hand");
		lineDec.css("cursor", "hand");
	}

	allowBetButtons() {
		$(`#` + ELEMENT_IDS.BUTTON_BET_INC).prop(
			"disabled",
			!this.wallet.nextCreditBet()
		);
		$(`#` + ELEMENT_IDS.BUTTON_BET_DEC).prop(
			"disabled",
			!this.wallet.prevCreditBet()
		);
		$(`#` + ELEMENT_IDS.BUTTON_COIN_INC).prop(
			"disabled",
			!this.wallet.nextCoin()
		);
		$(`#` + ELEMENT_IDS.BUTTON_COIN_DEC).prop(
			"disabled",
			!this.wallet.prevCoin()
		);
		$(`#` + ELEMENT_IDS.BUTTON_LINES_INC).prop(
			"disabled",
			!this.wallet.nextLinesCount()
		);
		$(`#` + ELEMENT_IDS.BUTTON_LINES_DEC).prop(
			"disabled",
			!this.wallet.prevLinesCount()
		);
	}

	highlightWin() {
		let winElement = document.getElementById(ELEMENT_IDS.WIN);
		$(winElement).removeClass("desktopWinBounce");
		$(winElement).width();
		$(winElement).addClass("desktopWinBounce");
		$(winElement).unbind("animationend");
		$(winElement).on("animationend", () => {
			$(winElement).removeClass("desktopWinBounce");
		});
	}

	resetWin() {
		$("#" + ELEMENT_IDS.WIN).removeClass("desktopWinBounce");
	}

	winToBalance(run: boolean = true) {
		return new Promise<void>((res) => {
			if (!this.winToBalanceRunning && run) {
				this.winToBalanceRunning = true;

				let winElement = document.getElementById(ELEMENT_IDS.WIN);
				let text = winElement.textContent;
				// wrap every letter in <span>
				winElement.innerHTML = winElement.textContent.replace(
					/\S/g,
					"<span class='win-letter'>$&</span>"
				);

				$.each($(winElement).children("span"), (i, el) => {
					this.winToBalancePromises.push(this.animateLetter(i, el));
				});
				$(winElement).append(text);
			}
			Promise.all(this.winToBalancePromises).then(() => {
				$("#" + ELEMENT_IDS.WIN_BOX).removeClass("bar-bottom-box-win");
				this.winToBalanceRunning = false;
				this.winToBalancePromises.length = 0;
				res();
			});
		});
	}

	animateLetter(i: number, el: HTMLElement) {
		return new Promise<void>((res) => {
			let obj = { x: 0, y: 0, opacity: 1, scale: 1 };
			let path = [
				[0, 0, 50, 50, 100, 50],
				[100, 50, 150, 50, 200, 0],
			];
			createjs.Tween.get(obj)
				.wait(i * 69)
				.to(
					{ guide: { path: path[0] }, opacity: 1, scale: 1.3 },
					250,
					EASE.SINE_I
				)
				.to(
					{ guide: { path: path[1] }, opacity: 0, scale: 1 },
					250,
					EASE.SINE_O
				)
				.call(() => {
					el.remove();
					res();
				})
				.on("change", (event) => {
					let x = event.target.target.x.toString();
					let y = event.target.target.y.toString();
					let opacity = event.target.target.opacity.toString();
					let scale = event.target.target.scale.toString();
					$(el).css({
						transform:
							"translateX(-" +
							x +
							"px) translateY(-" +
							y +
							"px) scale(" +
							scale +
							")",
						opacity: opacity,
					});
				});
		});
	}

	fadeOutWin() {
		return new Promise<void>((res) => {
			$("#mxWin, #mxWinReal").css("opacity", 0);
			setTimeout(() => {
				$("#mxWin, #mxWinReal").css("opacity", 1);
				res();
			}, 200);
		});
	}

	setOnClick(func: any) {
		this.onClick = func;
		this.autostart?.setOnClick(this.onClick);
	}

	createRespins(): HTMLElement {
		this.respins = document.createElement("div");
		this.respins.classList.add("mx-bar-respin");
		this.respins.style.display = "none";
		return this.respins;
	}

	showRespins(): void {
		if (this.respins) this.respins.style.display = "block";
	}

	updateRespins(
		respin: number,
		maxRespin: number,
		text: string = "Respins"
	): void {
		if (this.config.get(CONFIG_PARAMS.LEGISLATION) === "it") {
			if (respin > 0)
				this.respins.innerText =
					text + " " + respin.toString() + "/" + maxRespin.toString();
			else this.respins.innerText = "";
		}
	}
}
